import alreadyTableBody from './alreadyTableBody';
import createTableEmpty from './createTableEmpty';

// ----------------------------------------------------------------------------

function alreadyTableEmpty(element: HTMLElement, config: Record<string, any> = {}): HTMLElement {
    let elTableEmpty = element.querySelector('.table-empty') as HTMLElement | undefined;

    if (!elTableEmpty) {
        const elTableBody = alreadyTableBody(element, config.tbody);

        elTableEmpty = createTableEmpty(element, config);
        elTableBody.appendChild(elTableEmpty);
    }

    return elTableEmpty;
}

// ----------------------------------------------------------------------------

export default alreadyTableEmpty;
